import { Link } from 'react-router';
import './Home.css';

import img_web from  "../images/web.png";
import img_sistemas from  "../images/sistemas.png";
import img_app from  "../images/app.png";
import img_html from  "../images/html.jpg";
import img_js from  "../images/js.jpg";
import img_cordova from  "../images/cordova.jpg";
import img_ubuntu from  "../images/ubuntu.jpg";
import img_apache from  "../images/apache.jpg";
import img_php from  "../images/php.jpg";
import img_mysql from  "../images/mysql.jpg";
import img_mongo from  "../images/mongo.jpg";
import img_boots from  "../images/boots.jpg";
import img_node from  "../images/node.jpg";
import img_knock from  "../images/knock.jpg";
import img_openvpn from  "../images/openvpn.png";
import img_wordpress from  "../images/wordpress.png";
import img_phones2 from  "../images/phones2.fw-1.png";
import img_phones from  "../images/phones-e1476134562426.png";
import img_red from  "../images/red.png";
import img_seg from  "../images/seg.png";
import img_diseno from  "../images/diseno.png";
import img_cohete from  "../images/cohete.gif";


function Home() {
    return (
        <>
            <div id="slogan" className="container-fluid d-flex flex-column justify-content-center text-white" style={{ minHeight: '640px', backgroundSize: 'cover' }}>
                <div className="container">
                    <div className="col-md-7 offset-md-1">
                        <h1 className='font-weight-bold'>Bienvenido a Nuvlar</h1>
                        <br />
                        <h2>
                            TECNOLOGÍAS DE INFORMACIÓN PARA LA VIDA
                        </h2>
                    </div>
                </div>
            </div>

            <div className="container my-5">
                <div className="row">
                    <div className="col-md-8 offset-md-2 text-md">
                        <p>Nuvlar es una empresa formada por profesionales dedicados a crear soluciones para el mundo moderno, desarrollando aplicaciones móviles, sistemas y sitios web a la medida, siempre únicos e innovadores.</p>
                    </div>
                    {/* <div className="col-md-4 text-center">
                        <Link className="btn btn-outline-primary p-3" to="/contacto">CONTÁCTANOS</Link>
                    </div> */}
                </div>
            </div>

            <div className="container my-5 text-center">
                <div className="row">
                    <div className="col">
                        <h3 className='text-grey'>LO QUE HACEMOS</h3>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-4 p-5">
                        <img alt="" className='img-fluid' src={img_web} />
                        <h5 className='pt-5'>DESARROLLO WEB</h5>
                        <p>Conocemos sobre desarrollo web. Los sitios que desarrollamos son responsivos, dinámicos y escalables.</p>
                    </div>
                    <div className="col-lg-4 p-5">
                        <img alt="" className='img-fluid' src={img_sistemas} />
                        <h5 className='pt-5'>SISTEMAS A LA MEDIDA</h5>
                        <p>Sistemas informáticos para tu empresa. Eficientamos procesos de producción, inventario, clientes, ventas y más. Utilizamos los más avanzados lenguajes de programación.</p>
                    </div>
                    <div className="col-lg-4 p-5">
                        <img alt="" className='img-fluid' src={img_app} />
                        <h5 className='pt-5'>APLICACIONES MÓVILES</h5>
                        <p>Ingresa al mundo movil con Nuvlar; Desarrollamos tu app con las últimas técnicas de programación. Dominamos todos los sistemas operativos.</p>
                    </div>
                </div>
            </div>

            <div className="container-fluid py-5 text-white bg-light-blue">
                <div className="container">
                    <div className="row text-center">
                        <div className="col">
                            <h3 className='text-white'>CÓMO LO HACEMOS</h3>
                            <p className='text-md'>Trabajamos con las tecnologías de vanguardia</p>
                        </div>
                    </div>

                    <div className="row text-center text-lg-left">
                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-12 col-lg-6 px-0">
                                    <a target='_blank' rel="noreferrer" href="http://en.wikipedia.org/wiki/HTML5">
                                        <img alt="" src={img_html} className="img-fluid" />
                                    </a>
                                </div>
                                <div className="col col-lg-6">
                                    <b className='text-grey-blue'>HTML5 + CSS3</b>
                                    <p>Dominamos el lenguaje de programación más popular del momento, que nos permite ofrecerte sistemas web dinámicos y muy rápidos.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-12 col-lg-6 px-0">
                                    <a target='_blank' rel="noreferrer" href="http://es.wikipedia.org/wiki/JavaScript">
                                        <img alt="" src={img_js} className="img-fluid" />
                                    </a>
                                </div>
                                <div className="col col-lg-6">
                                    <b className='text-grey-blue'>JAVASCRIPT</b>
                                    <p>Dominamos el lenguaje de programación más popular del momento, que nos permite ofrecerte sistemas web dinámicos y muy rápidos.</p>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="row">
                                <div className="col-12 col-lg-6 px-0">
                                    <a target='_blank' rel="noreferrer" href="http://cordova.apache.org/">
                                        <img alt="" src={img_cordova} className="img-fluid" />
                                    </a>
                                </div>
                                <div className="col col-lg-6">
                                    <b className='text-grey-blue'>APACHE CORDOVA™</b>
                                    <p>Desarrollamos tu aplicación móvil para las plataformas más populares, a un precio muy bajo y en tiempo récord.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <hr className='hr-small' />

                    <div className="row d-flex justify-content-center py-5">
                        <div className="col-md-1 col-3  px-0">
                            <a target='_blank' rel="noreferrer" href="http://ubuntu.com/server">
                                <img alt="" src={img_ubuntu} className="img-fluid" />
                            </a>
                        </div>
                        <div className="col-md-1 col-3  px-0">
                            <a target='_blank' rel="noreferrer" href="http://httpd.apache.org/">
                                <img alt="" src={img_apache} className="img-fluid" />
                            </a>
                        </div>
                        <div className="col-md-1 col-3  px-0">
                            <a target='_blank' rel="noreferrer" href="http://php.net/">
                                <img alt="" src={img_php} className="img-fluid" />
                            </a>
                        </div>
                        <div className="col-md-1 col-3  px-0">
                            <a target='_blank' rel="noreferrer" href="http://www.mysql.com/">
                                <img alt="" src={img_mysql} className="img-fluid" />
                            </a>
                        </div>
                        <div className="col-md-1 col-3  px-0">
                            <a target='_blank' rel="noreferrer" href="https://www.mongodb.org/">
                                <img alt="" src={img_mongo} className="img-fluid" />
                            </a>
                        </div>
                        <div className="col-md-1 col-3  px-0">
                            <a target='_blank' rel="noreferrer" href="http://getbootstrap.com/">
                                <img alt="" src={img_boots} className="img-fluid" />
                            </a>
                        </div>
                        <div className="col-md-1 col-3  px-0">
                            <a target='_blank' rel="noreferrer" href="https://nodejs.org/en/">
                                <img alt="" src={img_node} className="img-fluid" />
                            </a>
                        </div>
                        <div className="col-md-1 col-3  px-0">
                            <a target='_blank' rel="noreferrer" href="http://knockoutjs.com/">
                                <img alt="" src={img_knock} className="img-fluid" />
                            </a>
                        </div>
                        <div className="col-md-1 col-3  px-0">
                            <a target='_blank' rel="noreferrer" href="https://openvpn.net/">
                                <img alt="" src={img_openvpn} className="img-fluid" />
                            </a>
                        </div>
                        <div className="col-md-1 col-3  px-0">
                            <a target='_blank' rel="noreferrer" href="https://wordpress.org/">
                                <img alt="" src={img_wordpress} className="img-fluid" />
                            </a>
                        </div>
                    </div>
                    <hr className='hr-small' />
                </div>
            </div>

            <div className="container my-5">
                <div className="row flex-column-reverse flex-md-row">
                    <div className="col-md-6">
                        <img alt="" src={img_phones2} className="img-fluid" />
                    </div>
                    <div className="col-md-6">
                        <h1>Aplicaciones de todo y para todos</h1>
                        <img alt="" src={img_phones} className='py-3' />
                        <p className='text-md'>Somos desarrolladores autorizados en las tiendas de Apps de los sistemas operativos móviles más populares.</p>
                    </div>
                </div>
            </div>

            <div className="d-flex bg-light-grey">
                <div className="container my-5 text-center">
                    <div className="row">
                        <div className="col">
                            <h3 className='text-grey'>LO QUE TAMBIÉN HACEMOS</h3>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-lg-4 p-5">
                            <img alt="" className='img-fluid' src={img_red} />
                            <h5 className='pt-5'>REDES</h5>
                            <p>Diseñamos, ampliamos o modificamos la red interna de tu empresa. Eficientamos el tráfico de datos y ponemos especial atención en la seguridad. Implementamos VLANs, firewalls y VoIP.</p>
                        </div>
                        <div className="col-lg-4 p-5">
                            <img alt="" className='img-fluid' src={img_seg} />
                            <h5 className='pt-5'>SEGURIDAD INFORMÁTICA</h5>
                            <p>Protección total en este mundo digital. Encriptación de comunicaciones, dispositivos y tráfico de internet para que tu información nunca caiga en las manos equivocadas.</p>
                        </div>
                        <div className="col-lg-4 p-5">
                            <img alt="" className='img-fluid' src={img_diseno} />
                            <h5 className='pt-5'>DISEÑO GRÁFICO</h5>
                            <p>Desarrollamos la imágen de tu marca, tu producto o tu servicio, apegándonos a las últimas tendencias.</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container my-5">
                <div className="row flex-column-reverse flex-md-row align-items-center">
                    <div className="col-md-3">
                        <img alt="" src={img_cohete} className="img-fluid" style={{ borderRadius: '50%' }} />
                    </div>
                    <div className="col-md-9">
                        <h1>Desarrollamos en tiempo record</h1>
                        <p className='text-md'>
                            Utilizamos metodologías y lenguajes de desarrollo que permiten mantener costos y tiempos al mínimo.
                            <br /><br />
                            Contáctanos para una cotización sin costo.
                        </p>
                    </div>
                </div>
            </div>

        </>
    )
}

export default Home
